import React from 'react'
import classNames from 'classnames'

import SidePanelResizable from './resizable'

const MainPanel = ({ children }) => {
  return (
    <div className="flexbox flexbox-grow flexbox-no-shrink height-full">
      {children}
    </div>
  )
}

const NoteList = ({ children, className, wrapperClassName, wrapperStyle }) => {
  return (
    <div
      className={classNames(
        'sidepanel no-print slite-design-system',
        'flexbox flexbox-no-shrink flexbox-no-grow flexbox-column',
        'overflow-hidden',
        className
      )}
    >
      <div
        className={classNames(
          'flexbox flexbox-column flexbox-grow',
          wrapperClassName
        )}
        style={wrapperStyle}
      >
        {children}
      </div>
    </div>
  )
}

export { SidePanelResizable, MainPanel, NoteList }
